import {
    createRouter,
    createWebHistory
} from 'vue-router';
import RegistrationForm from '../views/RegistrationForm/RegistrationForm.vue';
import ReferralPatientForm from '../views/ReferralPatientForm/ReferralPatientForm.vue';
import store from '@/store'; // 引入 Vuex store
const routes = [{
        path: '/',
        redirect: '/registration', // 默认跳转到登录页
    },
    {
        path: '/registration',
        name: 'Registration',
        component: RegistrationForm,
    },
    {
        path: '/referral-patient',
        name: 'ReferralPatient',
        component: ReferralPatientForm,
        meta: {
            requiresAuth: true, // 需要登录才能访问
        },

    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// 初始化时检查并清理状态
const initializeState = () => {
    // 清除所有相关的存储
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userInfo');

    // 重置 store 状态
    store.state.isAuthenticated = false;
    store.state.userInfo = null;
};



// 路由守卫
router.beforeEach((to, from, next) => {
    // const isAuthenticated = store.getters.isAuthenticated; // 从 Vuex 获取登录状态
    // const userInfo = store.getters.userInfo; // 从 Vuex 获取用户信息
    const isAuthenticated = store.state.isAuthenticated; // 直接从 state 获取登录状态
    const userInfo = store.state.userInfo; // 直接从 state 获取用户信息
    console.log('路由守卫用户信息:', userInfo, isAuthenticated);
    if (to.path === '/' || to.path === '/registration') {
        //initializeState();
    }
    
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        next('/'); // 如果需要身份验证且未登录，重定向到登录页
    } else if (isAuthenticated && (to.path === '/' || to.path === '/registration')) {
        //next('/referral-patient'); // 如果已登录且访问登录或注册页，重定向到提交资料页
        // 使用 query 参数携带用户信息
        next({
            path: '/referral-patient',
            query: userInfo
            // query: {
            //     userInfo: JSON.stringify(userInfo)
                
            // }
        });
    } else {
        next(); // 允许访问
    }
});


export default router;